
import classNames from 'classnames';

const CustomButton = ({
  label,
  variant = 'red',
  size = 'small',
  className = '',
  onClick,
  href, 
  target = '_self', 
}) => {
  const buttonClass = classNames('button', className, {
    'button-red-small': variant === 'red' && size === 'small',
    'button-black-small': variant === 'black' && size === 'small',
    'button-outline-small': variant === 'outline' && size === 'small',
    'button-red-large': variant === 'red' && size === 'large',
    'button-black-large': variant === 'black' && size === 'large',
    'button-outline-large': variant === 'outline' && size === 'large',
  });

  if (href) {
    return (
      <a href={href} className={buttonClass} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined}>
        {label}
      </a>
    );
  }

  return (
    <button className={buttonClass} onClick={onClick}>
      {label}
    </button>
  );
};

export default CustomButton;
